import { Dic } from "@src/common/utils";
import utils from "@src/common/utils";
const viewTableOption = function (that) {
  return {
    page: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "200%",
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    labelSuffix: " ：",
    labelWidth: "98px",
    dialogWidth: "800px",
    viewDialogWidth: "700",
    emptyText: "暂无查看数据",
    column: [
      {
        label: "sheet页名称",
        prop: "sheetName",
        overHidden: true,
      },
      {
        label: "行数",
        prop: "orderNumber",
        overHidden: true,
      },
      {
        label: "作业类型",
        prop: "operateType",
        searchPlaceholder: "请选择作业类型",
        formatter: (row, value) => {
          if (Number(value) === 1) {
            return "装货";
          } else if (Number(value) === 2) {
            return "卸货";
          } else if (Number(value) === 3) {
            return "过车";
          }
          return "";
        },
      },
      // {
      //   label: "操作类型",
      //   prop: "passType",
      //   searchPlaceholder: "请选择操作类型",
      //   formatter: (row, value) => {
      //     if (Number(value) === 1) {
      //       return "倒入";
      //     } else if (Number(value) === 2) {
      //       return "倒出";
      //     }
      //     return "";
      //   },
      //   columnWidth: "200",
      // },
      {
        label: "失败原因",
        prop: "remarks",
        overHidden: true,
      },
    ],
  };
};
export default viewTableOption;
